// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3fCYq","file":"styles_file__3Ca6Y"};